function is_function(func) {
  return typeof window[func] !== 'undefined' && $.isFunction(window[func]);
}
var getSiblings = function (elem) {

  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = elem.parentNode.firstChild;

  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling
  }

  return siblings;

};

(function(doc, proto) {
  try { // check if browser supports :scope natively
    doc.querySelector(':scope body');
  } catch (err) { // polyfill native methods if it doesn't
  ['querySelector', 'querySelectorAll'].forEach(function(method) {
    var nativ = proto[method];
    proto[method] = function(selectors) {
        if (/(^|,)\s*:scope/.test(selectors)) { // only if selectors contains :scope
          var id = this.id; // remember current element id
          this.id = 'ID_' + Date.now(); // assign new unique id
          selectors = selectors.replace(/((^|,)\s*):scope/g, '$1#' + this.id); // replace :scope with #ID
          var result = doc[method](selectors);
          this.id = id; // restore previous id
          return result;
        } else {
          return nativ.call(this, selectors); // use native code for other selectors
        }
      }
    });
}
})(window.document, Element.prototype);

const elmHamburger = document.getElementById('drawerBtn');
const closeMenu = document.getElementById('closeMenu');
const drawerMenu = document.getElementById('drawer');
const header = document.getElementById('header');
const headerNav = document.querySelector('#header > nav');
const headerLogo = document.querySelector('#header .navbar-brand');
const drawerHeader = document.querySelector('#drawer header');
const gNavItems = document.querySelectorAll('#drawer .menu-item');
const drawerDropdownTogglers = document.querySelectorAll('#drawerNav > li > button.icn-toggler');
const innerDrawerDropdownTogglers = document.querySelectorAll('#drawer .dropdown .dropdown-menu button.icn-toggler');
const drawerDropdownMenus = document.querySelectorAll('#drawer .dropdown-menu');
const back_btn = document.querySelector('#drawer .back-btn');
const menu_label = document.querySelector('#drawer .menu-label');
const menu_label_text = menu_label.innerHTML;

const bars = document.querySelectorAll('.menu-bar');
const menu = document.getElementById('menu');
const menuButton = document.querySelector('.menu-button');
const page = document.getElementById("main");
const skipBtn = document.getElementById("skipSection");
const hoverableCards = document.querySelectorAll(".card.hoverable");


const dropdownTogglers = document.querySelectorAll('#main-menu > li.dropdown > a');
[].forEach.call(dropdownTogglers, function(dropdownToggle) {
  dropdownToggle.addEventListener('mouseenter', function(e) {
    let activeDropdown = document.querySelector('#header a.is-open');
    if (e.target.classList.contains('dropdown-toggle')) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof(activeDropdown) != 'undefined' && activeDropdown != null) {
        activeDropdown.classList.remove('is-open');
      }
      e.target.classList.add('is-open');
    } else {
      if (typeof(activeDropdown) != 'undefined' && activeDropdown != null) {
        activeDropdown.classList.remove('is-open');
      }
    }
  });
});

const ctaTogglers = document.querySelectorAll('#headerCta > li.dropdown > a');
[].forEach.call(ctaTogglers, function(dropdownToggle) {
  dropdownToggle.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });

  dropdownToggle.addEventListener('mouseenter', function(e) {
    let activeDropdown = document.querySelector('#headerCta a.is-open');
    if (e.target.classList.contains('dropdown-toggle')) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof(activeDropdown) != 'undefined' && activeDropdown != null) {
        activeDropdown.classList.remove('is-open');
      }
      e.target.classList.add('is-open');
    } else {
      if (typeof(activeDropdown) != 'undefined' && activeDropdown != null) {
        activeDropdown.classList.remove('is-open');
      }
    }
  });
});

header.addEventListener('mouseleave', function(e) {
  let activeDropdown = document.querySelector('#header a.is-open');
  if (typeof(activeDropdown) != 'undefined' && activeDropdown != null) {
    activeDropdown.classList.remove('is-open');
  }
});

const drawer_timeline = gsap.timeline({paused: true});
let open = false;
let windowWidth = window.innerWidth;
drawer_timeline
.to(drawerMenu, {
  duration: 0.4,
  x: '0px',
  ease: Expo.easeinOut
}, '<+0.25')
.to(drawerHeader, {
	delay: 0.1,
	duration: 0.25,
  autoAlpha: 1,
  ease: Sine.easeInOut
}, '>');


document.addEventListener('resize', () => {
  windowWidth = window.innerWidth;
  if (drawerMenu.classList.contains('is-open') === true) {
    gsap.to(headerNav, {x: windowWidth - 65});
  }
});

closeMenu.addEventListener('click', () => {
    menu_label.innerHTML = menu_label_text;
    drawer_timeline.reverse();
    elmHamburger.classList.remove('menu-is-open-navi');
    drawerMenu.classList.remove('is-open');
    open = false;
    for (var i = 0; i < drawerDropdownMenus.length; i++) {
      drawerDropdownMenus[i].classList.remove('dropdown-is-open');
    }
    header.classList.remove('menu-is-open-navi');
    gsap.to(back_btn, {autoAlpha: 0});
});

elmHamburger.addEventListener('click', () => {
    drawer_timeline.play();
    drawerMenu.classList.add('is-open');
    elmHamburger.classList.add('menu-is-open-navi');
    open = true;

    header.classList.add('menu-is-open-navi');
});

[].forEach.call(drawerDropdownTogglers, function(dropdownIcon) {
  const parent = dropdownIcon.parentNode;
  const dropdownToggle = parent.querySelector(':scope > .nav-link');
  dropdownToggle.addEventListener('click', function(e) {
    window.location.href = e.target.getAttribute('href');
  });

  dropdownIcon.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let dropdown_target = dropdownToggle.getAttribute('href');
    let dropdown_label = dropdownToggle.innerHTML;
    gsap.to(back_btn, {autoAlpha: 1, ease: Linear.easeInOut, duration: 0.5});
    menu_label.innerHTML = dropdown_label;
    menu_label.setAttribute('href', dropdown_target);
    var siblings = getSiblings(parent);
    var menu = dropdownToggle.nextElementSibling;
    var inner_dropdowns = parent.querySelectorAll('.dropdown-menu');
    var parentColumn = dropdownToggle.parentNode.parentNode;
    if (menu.classList.contains('dropdown-is-open') === true) {
      [].forEach.call(inner_dropdowns, function(inner_dropdown) {
        inner_dropdown.classList.remove('dropdown-is-open');
        inner_dropdown.classList.remove('show');
      })
      menu.classList.remove('dropdown-is-open');
      parent.classList.remove('level-2-is-open');
    } else {
      [].forEach.call(siblings, function(sibling) {
        var sibling_dropdown = sibling.querySelectorAll('.dropdown-menu');
        if (sibling_dropdown.length) {
          for (var i = sibling_dropdown.length - 1; i >= 0; i--) {
            sibling_dropdown[i].classList.remove('dropdown-is-open');
          }
        }
      })
      menu.classList.add('dropdown-is-open');        
      parent.classList.add('level-2-is-open');        
    }

  });
});


back_btn.addEventListener('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  const level2 = document.querySelector('#drawer .level-2-is-open');

  if (level2 !== null) {
    level2.parentNode.classList.remove('dropdown-is-open');
    level2.querySelector('a').classList.remove('active');
    level2.querySelector('.dropdown-menu').classList.remove('dropdown-is-open');
    level2.classList.remove('level-2-is-open');
    menu_label.innerHTML = 'MENU';
    menu_label.setAttribute('href', '#');
    gsap.to(back_btn, {autoAlpha: 0});
  }

});
